<div class="onboarding-overlay" *ngIf="onboardingState.isActive">
  <div class="onboarding-modal">
    <div class="modal-content">
      <div class="step-content">
        <h2 class="step-title">{{ steps[onboardingState.currentStep].title }}</h2>
        <p class="step-description" *ngIf="steps[onboardingState.currentStep].content">
          {{ steps[onboardingState.currentStep].content }}
        </p>
      </div>

      <div class="progress-dots">
        <span 
          *ngFor="let step of steps; let i = index" 
          class="dot" 
          [class.filled]="i <= onboardingState.currentStep">
        </span>
      </div>

      <button class="btn-next" (click)="handleNext()">
        {{ steps[onboardingState.currentStep].buttonText }}
      </button>
    </div>
  </div>
</div>



